export function scanIdentity(scan = {}) {
  const provider = typeof scan.connector_name === "string" ? scan.connector_name.trim() : "";
  const label = typeof scan.connection_label === "string" ? scan.connection_label.trim() : "";
  const timestamp = scan.completed_at || scan.started_at;
  const date = timestamp ? new Date(timestamp) : null;
  return {
    name: label || provider || "CRM",
    provider,
    dateLabel: date && Number.isFinite(date.getTime()) ? date.toLocaleString() : "Date unavailable",
  };
}
